import { getServerURL } from '../../../../../Utils/getServerURL';

export interface IRapportParams {
  db: string;
  rapportId: string;
  rapportParams: object;
}

export const RapportQuery = (params: IRapportParams) => {
  const form = document.createElement('form');
  form.action = `${getServerURL()}/report?reportName=${
    params.rapportId
  }&DBName=${params.db}`;
  form.method = 'post';
  form.target = 'download' in HTMLAnchorElement.prototype ? '_self' : '_blank';

  const input = document.createElement('input');
  input.name = 'json';
  input.value = JSON.stringify(params.rapportParams);
  input.type = 'hidden';

  form.appendChild(input);
  document.body.appendChild(form);

  form.submit();

  document.body.removeChild(form);
};
